import React,{FC} from "react";
import { IconButton } from "@mui/material";
import { ExpandIcon, CollapseIcon } from "../../providers/RexIconsSVG/RexIconsSVG";


interface IExpandAndCollapse{
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}


export const Expand:FC<IExpandAndCollapse> = ({ onClick }) => {
  return (
    <IconButton color="inherit" onClick={onClick}>
      <ExpandIcon />
    </IconButton>
  );
};

export const Collapse:FC<IExpandAndCollapse> = ({ onClick }) => {
  return (
    <IconButton color="inherit" onClick={onClick}>
      <CollapseIcon />
    </IconButton>
  );
};
